import React from "react"
import NoContent from "components/elements/NoContent"
import EventResourcesView from "components/layout/EventResourcesView"
import SelectPrompt from "components/SelectPrompt"
import useModal from "services/useModal"
import {
  ModalName, EventCounts, DioboxEvent, Form,
} from "sharedTypes"
import { DIOBOX_FORMS_ARTICLE_LINK } from "utilities/externalLinks"
import { DropResult } from "react-beautiful-dnd"
import { useParams } from "react-router-dom"
import SelectedForm from "../SelectedForm/SelectedForm"
import EventFormListItems from "./EventFormListItems"

type Props = {
  counts: EventCounts
  event: DioboxEvent
  sortingEnabled: boolean
  forms: Form[]
  onDragEnd: (result: DropResult) => void
}

const EventForms = ({
  event,
  counts,
  sortingEnabled,
  forms,
  onDragEnd,
}: Props) => {
  const showModal = useModal()
  const { currency } = event
  const { forms: formsCount } = counts
  const { formId } = useParams<{ formId: string}>()

  if (!formsCount) {
    return <NoForms onClick={() => showModal(ModalName.FormForm)} />
  }

  return (
    <EventResourcesView
      listItems={(
        <EventFormListItems
          forms={forms}
          onDragEnd={onDragEnd}
          event={event}
          formId={formId}
          currency={currency}
          sortingEnabled={sortingEnabled}
        />
      )}
      showBorder={false}
      bgColor={formId ? "gray.50" : "white"}
      selectedItem={formId ? (
        <SelectedForm
          formId={formId}
          event={event}
          formsCount={formsCount}
        />
      ) : <SelectPrompt text="Select a Form" />}
    />
  )
}

const NoForms = ({ onClick }) => {
  const descriptionItems = [
    "You can create forms or tickets that allow guests to register for your event. Diobox provides various form types that offer different functionalities.",
  ]

  return (
    <NoContent
      title="Forms"
      icon="form-registration"
      horizontalCTAs
      descriptionItems={descriptionItems}
      callsToActions={[
        {
          icon: "plus-big",
          text: "Create First Form",
          action: onClick,
          isButton: true,
        },
        {
          icon: "book",
          text: "Learn more about Diobox Forms",
          link: DIOBOX_FORMS_ARTICLE_LINK,
        },
      ]}
    />
  )
}

export default EventForms
